<template>
  <div class="page">
    <!-- 统一风格页头 -->
    <div class="page-header">
      <div class="header-left">
        <h1 class="page-title">卡管理</h1>
      </div>
      <div class="header-right">
        <el-button size="mini" type="warning" @click="onAddButton" class="btn-add">新增卡片</el-button>
      </div>
    </div>

    <div class="layout">
      <!-- 统一风格搜索区 -->
      <div class="search-card">
        <div class="search-row">
          <el-input
              v-model="listQuery.nameLike"
              placeholder="名稱"
              prefix-icon="el-icon-search"
          ></el-input>

          <div>
            <el-select v-model="listQuery.titleId" clearable placeholder="全部主題">
              <el-option
                  v-for="item in cardTitle"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
              ></el-option>
            </el-select>
          </div>

          <div>
            <el-select v-model="listQuery.propertyId" clearable placeholder="全部屬性">
              <el-option
                  v-for="item in cardProperty"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
              ></el-option>
            </el-select>
          </div>

          <el-input
              v-model="listQuery.contentLike"
              placeholder="介紹"
              prefix-icon="el-icon-search"
          ></el-input>

          <div class="search-buttons">
            <el-button size="small" type="warning" @click="onSearch" icon="el-icon-search">搜尋</el-button>
            <el-button size="small" @click="onReset" icon="el-icon-refresh">重置</el-button>
          </div>
        </div>
      </div>

      <!-- 统一风格 PC表格 + 手机卡片 -->
      <div class="table-container">
        <!-- PC端表格（≥768px显示） -->
        <div class="pc-table">
          <el-table
              @sort-change="handleSortChange"
              :data="tableData"
              style="width:100%"
              border
              stripe
              size="small"
              :empty-text="tableData.length === 0 ? '暫無數據' : ''"
          >
            <el-table-column label="#" type="index" width="50" align="center"></el-table-column>

            <el-table-column prop="imageUrl" label="圖片" align="center" min-width="120">
              <template slot-scope="{ row }">
                <el-image
                    v-if="row.image"
                    :src="row.image"
                    fit="cover"
                    style="width:40px;height:40px;border-radius:4px"
                ></el-image>
                <span v-else>-</span>
              </template>
            </el-table-column>

            <el-table-column prop="name" label="名稱" align="center" sortable="custom" min-width="120"></el-table-column>

            <el-table-column label="主題" align="center" min-width="100">
              <template slot-scope="{ row }">
                {{ getTitleName(row.titleId) }}
              </template>
            </el-table-column>

            <el-table-column label="屬性" align="center" min-width="100">
              <template slot-scope="{ row }">
                {{ getPropertyName(row.propertyId) }}
              </template>
            </el-table-column>

            <el-table-column prop="content" label="介紹" align="center" min-width="180"></el-table-column>
            <el-table-column prop="probability" label="概率" align="center" min-width="100">
              <template slot-scope="{ row }">
                {{ row.probability }}%
              </template>
            </el-table-column>

            <el-table-column label="操作" width="120" align="center">
              <template slot-scope="scope">
                <el-button type="text" size="small" @click="onEditButton(scope.row)" icon="el-icon-edit">編輯</el-button>
<!--                <el-button type="text" size="small" @click="onDeleteButton(scope.row.id)" icon="el-icon-delete">刪除</el-button>-->
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>

    <!-- 分页 -->
    <div class="pagination-wrap">
      <Pagination
          v-show="total > 0"
          :total="total"
          :page.sync="listQuery._page"
          :limit.sync="listQuery._limit"
          @pagination="getCards"
      />
    </div>

    <!-- 删除弹窗 -->
    <deleteDialog
        titleCh="您確定要刪除此卡片嗎？"
        :centerDialogVisible="centerDialogVisible"
        @confirmFunction="confirmFunction"
        @onCancelButton="onCancelButton"
    ></deleteDialog>

    <!-- 新增卡片弹窗 -->
    <el-dialog
        title="新增卡片"
        :visible.sync="addDialogVisible"
        width="600px"
        append-to-body
        close-on-click-modal
    >
      <el-form ref="form" :model="form" :rules="rules" label-width="80px" size="small">
        <el-form-item label="名稱" prop="name">
          <el-input v-model="form.name" placeholder="請輸入名稱"></el-input>
        </el-form-item>

        <el-form-item label="主題" prop="titleId">
          <el-select v-model="form.titleId" placeholder="請選擇主題" clearable>
            <el-option
                v-for="item in cardTitle"
                :key="item.id"
                :label="item.name"
                :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="屬性" prop="propertyId">
          <el-select v-model="form.propertyId" placeholder="請選擇屬性" clearable>
            <el-option
                v-for="item in cardProperty"
                :key="item.id"
                :label="item.name"
                :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="介紹" prop="content">
          <el-input v-model="form.content" type="textarea" rows="3" placeholder="請輸入介紹"></el-input>
        </el-form-item>

        <el-form-item label="概率" prop="probability">
          <el-input
              v-model.number="form.probability"
              placeholder="請輸入概率（1-100）"
              type="number"
              min="1"
              max="100"
              oninput="if(value>100)value=100;if(value<1)value=1"
          ></el-input>
        </el-form-item>

        <el-form-item label="卡片圖片">
          <upload @childByValue="childByValue" :isImgUpload="true" :imageurl="form.imageUrl" buttonText="瀏覽"></upload>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="closeAddDialog">取 消</el-button>
        <el-button type="primary" @click="submitAddForm">確 認 新 增</el-button>
      </div>
    </el-dialog>

    <!-- 编辑弹窗 -->
    <el-dialog
        title="編輯卡片"
        :visible.sync="editDialogVisible"
        width="600px"
        append-to-body
        close-on-click-modal
    >
      <el-form ref="editForm" :model="editForm" :rules="rules" label-width="80px" size="small">
        <el-form-item label="名稱" prop="name">
          <el-input v-model="editForm.name" placeholder="請輸入名稱"></el-input>
        </el-form-item>

        <el-form-item label="主題" prop="titleId">
          <el-select v-model="editForm.titleId" placeholder="請選擇主題" clearable>
            <el-option
                v-for="item in cardTitle"
                :key="item.id"
                :label="item.name"
                :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="屬性" prop="propertyId">
          <el-select v-model="editForm.propertyId" placeholder="請選擇屬性" clearable>
            <el-option
                v-for="item in cardProperty"
                :key="item.id"
                :label="item.name"
                :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="介紹" prop="content">
          <el-input v-model="editForm.content" type="textarea" rows="3" placeholder="請輸入介紹"></el-input>
        </el-form-item>

        <el-form-item label="概率" prop="probability">
          <el-input
              v-model.number="editForm.probability"
              type="number"
              min="1"
              max="100"
              oninput="if(value>100)value=100;if(value<1)value=1"
              placeholder="請輸入概率（1-100）"
          ></el-input>
        </el-form-item>

        <el-form-item label="卡片圖片">
          <upload @childByValue="editChildByValue" :isImgUpload="true" :imageurl="editForm.image" buttonText="瀏覽"></upload>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="closeEditDialog">取 消</el-button>
        <el-button type="primary" @click="submitEditForm">保 存 修 改</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import Pagination from "@/components/Pagination";
import { getCardProperty, getCards, getCardTitle, addCard, editCard } from "@/api/setting";
import deleteDialog from "@/components/deleteDialog";
import upload from "@/components/upload";

export default {
  components: { deleteDialog, Pagination, upload },
  data() {
    return {
      total: 0,
      staffId: null,
      centerDialogVisible: false,
      addDialogVisible: false,
      editDialogVisible: false,
      currentId: null,
      listQuery: {
        titleId: null,
        propertyId: null,
        nameLike: null,
        contentLike: null,
        orderBy: null,
        _page: 1,
        _limit: 10,
      },
      form: {
        name: '',
        titleId: null,
        propertyId: null,
        content: '',
        probability: '',
        imageUrl: '',
      },
      editForm: {
        name: '',
        titleId: null,
        propertyId: null,
        content: '',
        probability: '',
        image: '',
      },
      rules: {
        name: [{ required: true, message: '請輸入名稱', trigger: 'blur' }],
        titleId: [{ required: true, message: '請選擇主題', trigger: 'change' }],
        propertyId: [{ required: true, message: '請選擇屬性', trigger: 'change' }],
        probability: [
          { required: true, message: '請輸入概率', trigger: 'blur' }
        ]
      },
      tableData: [],
      cardTitle: [],
      cardProperty: [],
    };
  },
  created() {
    this.getCards();
    this.getCardTitle();
    this.getCardProperty();
  },
  methods: {
    // 根据ID获取主题名称
    getTitleName(titleId) {
      const item = this.cardTitle.find(t => t.id === titleId);
      return item ? item.name : '-';
    },
    // 根据ID获取属性名称
    getPropertyName(propertyId) {
      const item = this.cardProperty.find(p => p.id === propertyId);
      return item ? item.name : '-';
    },

    // 图片上传
    childByValue(v) {
      this.form.imageUrl = v;
    },
    editChildByValue(v) {
      this.editForm.image = v;
    },

    // 新增
    onAddButton() {
      this.addDialogVisible = true;
    },
    closeAddDialog() {
      this.addDialogVisible = false;
      this.$nextTick(() => {
        this.form = { name: '', titleId: null, propertyId: null, content: '', probability: '', imageUrl: '' };
        this.$refs.form?.clearValidate();
      });
    },
    submitAddForm() {
      this.$refs.form.validate(valid => {
        if (!valid) return;
        addCard(this.form).then(() => {
          this.$message.success('新增成功');
          this.closeAddDialog();
          this.getCards();
        }).catch(() => {
          this.$message.error('新增失敗');
        });
      });
    },

    // 编辑
    onEditButton(row) {
      this.currentId = row.id;
      this.editForm = {
        name: row.name || '',
        titleId: row.titleId ?? null,
        propertyId: row.propertyId ?? null,
        content: row.content || '',
        probability: Number(row.probability) || 0,
        image: row.image || '',
      };
      this.editDialogVisible = true;
    },
    closeEditDialog() {
      this.editDialogVisible = false;
      this.currentId = null;
    },
    submitEditForm() {
      this.$refs.editForm.validate(valid => {
        if (!valid) return;
        editCard(this.currentId, this.editForm).then(() => {
          this.$message.success('修改成功');
          this.closeEditDialog();
          this.getCards();
        }).catch(() => {
          this.$message.error('修改失敗');
        });
      });
    },

    // 基础功能
    handleSortChange(col) {
      this.listQuery.orderBy = col.order ? `${col.prop} ${col.order === "descending" ? "desc" : "asc"}` : null;
      this.listQuery._page = 1;
      this.getCards();
    },
    onSearch() {
      this.listQuery._page = 1;
      this.getCards();
    },
    onReset() {
      Object.keys(this.listQuery).forEach(k => {
        this.listQuery[k] = null;
        if (k === "_page") this.listQuery[k] = 1;
        if (k === "_limit") this.listQuery[k] = 10;
      });
      this.getCards();
    },
    onCancelButton() {
      this.centerDialogVisible = false;
    },
    confirmFunction() {
      // 删除逻辑
    },
    onDeleteButton(id) {
      this.staffId = id;
      this.centerDialogVisible = true;
    },
    getCards() {
      const params = { ...this.listQuery, _page: this.listQuery._page - 1 };
      Object.keys(params).forEach(key => {
        if (params[key] == null) delete params[key];
      });
      getCards(params).then(v => {
        this.tableData = v.data || [];
        this.total = +v.headers["x-total-count"] || 0;
      });
    },
    getCardTitle() {
      getCardTitle().then(v => {
        this.cardTitle = v.data || [];
      });
    },
    getCardProperty() {
      getCardProperty().then(v => {
        this.cardProperty = v.data || [];
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.page {
  padding: 16px;
  background: #f5f7fa;
  min-height: calc(100vh - 60px);
}

.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0;
  padding-bottom: 12px;
  border-bottom: 1px solid #e4e7ed;

  .page-title {
    font-size: 20px;
    font-weight: 600;
    color: #B62D2E;
    margin: 0;
  }
}

.layout {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.search-card {
  background: #f8f9fa;
  padding: 16px;
  border-radius: 6px;
  margin-bottom: 20px;

  .search-row {
    display: flex;
    gap: 12px;
    flex-wrap: wrap;
    align-items: center;

    .el-input, .el-select {
      flex: 1;
      min-width: 160px;
    }

    .search-buttons {
      display: flex;
      gap: 8px;
    }
  }
}

.table-container {
  width: 100%;
}

.pagination-wrap {
  text-align: center;
  padding: 10px 0;
}

.dialog-footer {
  text-align: right;
}

@media (max-width: 768px) {
  .page { padding: 8px; }
  .layout { padding: 12px; }
  .search-row { flex-direction: column; align-items: stretch; }
  .pc-table { display: none; }
}
</style>